import { defineStore } from "pinia"

export const useAppStore = defineStore('app', {
  state: () => {
    return {
      host: '' as string,
      version: '' as string,
      checkAuth: false as boolean,
      projectTitle: '' as string,
      contactWay: '' as string,
      company: '' as string,
      copyright: '' as string,
      

      consoleContentHeight: 0,
      consoleContentWidth: 0
    }
  },
  getters: {},
  actions: {
    setDeviceContentHeight(value: number){
      this.consoleContentHeight = value
      console.log('工作区高度：',value + 'px')
    },
    setDeviceContentWidth(value: number){
      this.consoleContentWidth = value
      console.log('工作区宽度：',value + 'px')
    },
  }
})